import React, { FC, Suspense, lazy } from 'react';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import ReactDOM from 'react-dom/client';
import Spinner from './components/common/Spinner/Spinner';
import { BrowserRouter } from 'react-router-dom';
import { Toastr } from './components/common/Toastr';

import { ErrorBoundary } from 'react-error-boundary';

import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/globals.scss';

import 'react-toastify/dist/ReactToastify.css';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import 'yet-another-react-lightbox/styles.css';

import { RefetchProvider } from 'core/utils/context/EventContext';
import { ErrorFallback } from 'components/common/ui/ErrorFallback/ErrorFallback';
import { initAuthEvents } from 'core/services/auth/auth';

// ** Logo
import logoImg from "./assets/images/logo/LogoAp.png";

initAuthEvents();

const LazyApp: React.LazyExoticComponent<FC<{}>> = lazy(() =>
  import('./app/App').then((module) => ({ default: module.App })),
);
document.documentElement.style.setProperty("--logo", logoImg);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <BrowserRouter>
    <Suspense fallback={<Spinner />}>
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <Toastr />
        <RefetchProvider>
          <LazyApp />
        </RefetchProvider>
      </ErrorBoundary>
    </Suspense>
  </BrowserRouter>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA

//serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
